// 标签录入类型
export enum TagSelectType {
  // 普通勾选
  Common = 1,
  // 自定义录入
  Customize = 2,
}
